import { createFileRoute } from "@tanstack/react-router";

import { ProfilePage, profileSearchSchema } from "@/features/profile";

// «Профиль»: экран целиком из фичи `profile`. Период «Активности» — в search params,
// меняется без новой записи в истории браузера и без прокрутки наверх.
const ProfileRoute = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ProfilePage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
};

export const Route = createFileRoute("/profile")({
  validateSearch: profileSearchSchema,
  component: ProfileRoute,
});
